import { LoadingSmall } from "@/components/LoadingSmall";
import { ROUTES } from "@/constants/routeConstants";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { getRoleDetails } from "@/sideEffects/api";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import { UpdateRole } from "./UpdateRole";
import { DeleteRoleButton } from "../DeleteRoleButton";
import { BaseFormLayout } from "@/pages/shared/BaseFormLayout";

export const UpdateRolePage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const roleId = searchParams.get("Id");

  const { data: roleDetails, isLoading } = useQuery({
    queryKey: ["getRoleDetails", roleId],
    queryFn: () => getRoleDetails(Number(roleId)),
  });
  const roleDetailsData = roleDetails?.data;

  useBreadcrumbs([
    {
      name: t("entities.role"),
      path: ROUTES.ROLE,
    },
    {
      name: roleDetailsData
        ? `${t("common.detail", { entity: t("entities.role") })} - ${roleDetailsData?.roleName}`
        : "...",
      path: ROUTES.ROLE_DETAIL,
    },
  ]);

  if (!roleDetailsData || isLoading) {
    return (
      <div className="flex justify-center items-center h-full p-16">
        <LoadingSmall />
      </div>
    );
  }

  return (
    <BaseFormLayout
      title={t("common.entityDetail", { name: roleDetailsData?.roleName })}
      rightContent={<DeleteRoleButton roleId={roleDetailsData.id} />}
    >
      <UpdateRole role={roleDetailsData} />
    </BaseFormLayout>
  );
};
